import { Button, Tooltip } from 'antd';
import styles from './BulkActionBar.module.css';

interface BulkActionBarProps {
  totalCount: number;
  selectedCount: number;
  onMerge: () => void;
  onClearSelection: () => void;
}

export default function BulkActionBar({
  totalCount,
  selectedCount,
  onMerge,
  onClearSelection,
}: BulkActionBarProps) {
  const canMerge = selectedCount === 2;
  const mergeButton = (
    <Button type="primary" disabled={!canMerge} onClick={onMerge}>
      Merge Patients
    </Button>
  );

  return (
    <div className={styles.bar} role="toolbar" aria-label="Bulk actions">
      <span className={styles.totalLabel}>
        {totalCount} {totalCount === 1 ? 'patient' : 'patients'}
      </span>

      <span className={styles.selectedPill}>{selectedCount} selected</span>

      {canMerge ? (
        mergeButton
      ) : (
        <Tooltip title="Select exactly 2 patients to merge">
          <span>{mergeButton}</span>
        </Tooltip>
      )}

      <Button type="text" onClick={onClearSelection} className={styles.clear}>
        Clear selection
      </Button>
    </div>
  );
}
